export enum ModeToggle {
  LIGHT = "light",
  DARK = "dark",
}
